
<template>
    <div class="row iap-wrapper">
        <div class="row">
            <h3>Your Plan</h3>
            <img src="/images/SwingUPremiumLogoGreen.png" alt="SwingU Premium" width="120px">
        </div>
        <div v-if="viewModel.subscriptionOrigin === 'iphone'" id="iphone">
            <div class="row mt-20">
                <a href="https://buy.itunes.apple.com/WebObjects/MZFinance.woa/wa/DirectAction/manageSubscriptions" target="_blank" class="btn-cta">Manage Your Apple Subscription</a>
                <p class="italic light-gray mb-0">You will need to have Apple Music installed to manage your Apple subscription.</p>
            </div>
            <div class="row mt-20">
                <p class="instructions mb-0"><strong>To Manage Your Apple Subscription On Your iPhone:</strong></p>
                <ol class="mt-0">
                    <li>Open the "App Store" App on your iPhone</li>
                    <li>Tap your account in the upper right</li>
                    <li>Tap "Subscriptions"</li>
                    <li>Find and tap the "Golf GPS SwingU" to manage your subscription</li>
                </ol>
            </div>
        </div>
        <div v-if="viewModel.subscriptionOrigin === 'android'" id="android">
            <div class="row mt-20">
                <a href="https://play.google.com/store/account/subscriptions" target="_blank" class="btn-cta">Manage Your Google Subscription</a>
            </div>
            <div class="row mt-20">
                <p class="instructions mb-0"><strong>To Manage Your Google Subscription On Your Android Device:</strong></p>
                <ol class="mt-0">
                    <li>Open the "Play Store" App on your Android Phone</li>
                    <li>Tap the "Menu" icon in the upper left</li>
                    <li>Tap "Subscriptions"</li>
                    <li>Find and tap the "Golf GPS & Scorecard by SwingU" to manage your subscription</li>
                </ol>
            </div>
        </div>
        <div class="row footer-message-wrapper">
            <hr>
            <p class="mt-20 mb-0">We're here to help. No matter what the issue, don't hesitate to ask. Visit our support site at <a href="https://help.swingu.com" target="_blank">help.swingu.com</a> or email us at <a href="mailto:support@swingu.com" target="_blank">support@swingu.com</a>.</p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['viewModel'],

    data: () => {
        return {
            subscriptionType: '',
            debugMessages: []
        };
    },

    created: function() {
        this.debug('Loaded the IAP subscription component');
    },

    methods: {
        debug: function (message) {
            // console.log('DEBUG: ', message);
            // this.debugMessages.push(message);
        }
    }
}
</script>


<style scoped lang="scss">
@import "@/_var.scss";
</style>
